import { useEffect } from "react";
import { ProgressBar } from "components/molecules";
import { FileBase } from "./FileBase";
import { useUploadFile } from "../../hooks/useUploadFile";
import { UploadedFile } from "../../../../../../services/api/FileApiV2";

type FileUploadItemProps = {
  file: File;
  onFileUploaded: (fileId: UploadedFile) => unknown;
};

export const FileUploadItem = ({ file, onFileUploaded }: FileUploadItemProps) => {
  const { progress, uploadedFile } = useUploadFile(file);

  useEffect(() => {
    if (!!uploadedFile) onFileUploaded(uploadedFile);
  }, [uploadedFile, onFileUploaded]);

  return (
    <FileBase title={file.name}>
      <ProgressBar animate rounded value={progress} total={100} />
    </FileBase>
  );
};
